import { z } from 'zod'
export { workStatusCardSchema } from './workStatusCard'
export { automationCardSchema } from './automationCard'
export { automationSetupCardSchema } from './automationSetupCard'
export { clarificationCardSchema } from './clarificationCard'
export { connectCardSchema } from './connectCard'
export { integrationAccessRequestCardSchema } from './integrationAccessRequestCard'
export const artifactCardSchema = z.object({
  artifact_id: z.string(),
  document_id: z.string().optional(),
  kind: z.enum(['pdf', 'pptx', 'html', 'markdown', 'other']).catch('other'),
  title: z.string().optional(),
  version: z.number().optional(),
  size_label: z.string().optional(),
  preview_url: z.string().optional(),
  download_url: z.string().optional(),
})
export const confirmationCardSchema = z.object({
  proposal_id: z.string(),
  tool: z.string(),
  summary: z.string().optional(),
  description: z.string().optional(),
  arguments_preview: z.unknown().optional(),
  decision: z.enum(['approved', 'declined']).optional(),
  // Composio's own `destructiveHint`. Destructive actions take the same
  // approval path as any other write, so the card is the only thing that can
  // distinguish "draft an email" from "delete a thread" before the click.
  destructive: z.boolean().optional(),
})
